import { useState } from "react";
import {
  updateEmail,
  EmailAuthProvider,
  reauthenticateWithCredential,
  verifyBeforeUpdateEmail,
} from "firebase/auth";
import { updateDoc, doc } from "firebase/firestore";
import { auth, db } from "../../services/firebase/config";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

function EmailUpdate({ currentEmail, userId }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [password, setPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");

  const handleEmailUpdate = async () => {
    try {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(currentEmail, password);
      await reauthenticateWithCredential(user, credential);
      
      await verifyBeforeUpdateEmail(user, newEmail);
      
      // Update Firestore after verification
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, { email: newEmail });
      
      setOpenDialog(false);
      setPassword("");
      setNewEmail("");
      alert("Verification email sent. Please check your email to verify the change.");
    } catch (error) {
      console.error("Error updating email:", error);
      alert("Error updating email: " + error.message);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => setOpenDialog(true)}
        fullWidth
        sx={{ mt: 2 }}
      >
        Change Email Address
      </Button>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Update Email Address</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="New Email Address"
            type="email"
            fullWidth
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Current Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleEmailUpdate} color="primary">
            Update Email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EmailUpdate;